var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content pr-4"},_vm._l((_vm.backorderItems),function(product){return _c('backorder-item',{key:product._id,attrs:{"product":product}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }